"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmbedContainer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const EmbedContainer_module_css_1 = __importDefault(require("./EmbedContainer.module.css"));
const web_sds_c_1 = require("@snapchat/web-sds-c");
const GhostIcon_1 = require("../../icons/GhostIcon");
const react_1 = require("react");
const react_intl_1 = require("react-intl");
const web_graphene_reporting_1 = require("@snapchat/web-graphene-reporting");
const web_env_1 = require("@snapchat/web-env");
const urlToMetricPath = (urlString) => {
    if (!urlString)
        return "unavailable";
    const url = new URL(urlString);
    const path = url.hostname + url.pathname;
    return path.replaceAll(".", "_");
};
/**
 * @param openInSnapLink url string to where the user should be redirected
 * @returns Embed common container
 */
function EmbedContainer({ children, openInSnapLink, openInSnapMessage, emitWebAction, applyFocusModeStyling, }) {
    (0, react_1.useEffect)(() => {
        // Not supported in Firefox, @see https://developer.mozilla.org/en-US/docs/Web/API/Location/ancestorOrigins
        const ancestorOrigins = (0, web_env_1.getDocument)()?.location.ancestorOrigins || [];
        const parentURLString = ancestorOrigins.length > 0 ? ancestorOrigins[ancestorOrigins.length - 1] : "";
        // Emit parent URL for embeds
        void (0, web_graphene_reporting_1.incrementCounter)(`Embeds.ParentUrl.${urlToMetricPath(parentURLString)}.EmbeddedContent.${urlToMetricPath(openInSnapLink)}`);
    }, [openInSnapLink]);
    const onViewMoreClick = (0, react_1.useCallback)(() => {
        emitWebAction();
    }, [emitWebAction]);
    const openInSnapMessageOrDefault = openInSnapMessage || ((0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "vZuQb7", description: "View more on snapchat button for embeds", defaultMessage: "View more on Snapchat" }));
    return ((0, jsx_runtime_1.jsxs)("div", { className: applyFocusModeStyling ? EmbedContainer_module_css_1.default.focusModeStyling : EmbedContainer_module_css_1.default.container, children: [(0, jsx_runtime_1.jsx)("div", { className: applyFocusModeStyling ? EmbedContainer_module_css_1.default.focusModeBody : EmbedContainer_module_css_1.default.embedBody, children: children }), !applyFocusModeStyling && ((0, jsx_runtime_1.jsx)("div", { className: EmbedContainer_module_css_1.default.embedFooter, children: (0, jsx_runtime_1.jsxs)(web_sds_c_1.ButtonOrLink, { link: openInSnapLink, dataTest: "view-more-button", openLinkInNewTab: true, className: EmbedContainer_module_css_1.default.viewMoreButton, onClick: onViewMoreClick, children: [(0, jsx_runtime_1.jsx)(GhostIcon_1.GhostIconFilledBlack, { width: 18, height: 18 }), (0, jsx_runtime_1.jsx)("span", { children: openInSnapMessageOrDefault })] }) }))] }));
}
exports.EmbedContainer = EmbedContainer;
//# sourceMappingURL=EmbedContainer.js.map